import {
    HEADING_2_STYLES,
    HEADING_3_STYLES,
    Layout2ElementsWithImage,
    LinkButton,
    PARAGRAPH_INTRO_STYLES,
} from 'src/libs/design-system'
import { twMerge } from 'src/libs/tailwind-css'

interface PropositionSectionProps {
    title: string
    description: string | string[]
    ctaUrl?: string
    image: React.ReactElement<{ className?: string }>
    imageShadow?: boolean
    children?: React.ReactNode
    swapElementsWhenVertical?: boolean
    headingLevel?: 2 | 3
}

export function PropositionSection({
    title,
    description,
    ctaUrl,
    image,
    imageShadow,
    children,
    swapElementsWhenVertical,
    headingLevel = 2,
}: PropositionSectionProps) {
    const Heading = `h${headingLevel}` as const
    const headingStyles = { 2: HEADING_2_STYLES, 3: HEADING_3_STYLES }[headingLevel]

    return (
        <article>
            <Layout2ElementsWithImage
                image={image}
                element={
                    <div className="grid gap-16">
                        <div className="grid gap-6 justify-items-start">
                            <Heading className={twMerge(headingStyles, 'sm:w-[90%]')}>
                                {title}
                            </Heading>
                            <div className="grid gap-[1.2rem]">
                                {typeof description === 'string' ? (
                                    <p className={PARAGRAPH_INTRO_STYLES}>{description}</p>
                                ) : (
                                    description.map((desc, index) => (
                                        <p key={index} className={PARAGRAPH_INTRO_STYLES}>
                                            {desc}
                                        </p>
                                    ))
                                )}
                            </div>
                            {ctaUrl && (
                                <LinkButton href={ctaUrl} size="large" arrowRight alignLeft>
                                    Learn more
                                </LinkButton>
                            )}
                        </div>
                        {children}
                    </div>
                }
                imageShadow={imageShadow}
                swapElementsWhenVertical={swapElementsWhenVertical}
            />
        </article>
    )
}
